import { AddCompanyForm } from '@/modules/company/add-company';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/companies/add')({
  component: AddCompanyPage,
});

function AddCompanyPage() {
  return <AddCompanyForm />;
}
